<script>

  import { fly } from "svelte/transition";
  import ProgressBar from "../components/ProgressBar.svelte";
  import { AppAccessGranted } from "../stores/LoggedUser.js"

  let AppPassword = 'hoFame';

  $: updateLoginStatus($AppAccessGranted);

  function updateLoginStatus( app_access_grant ) {
    // if logged in, redirect to user login
    if( app_access_grant == 'true' ) {
      window.location.href = '#/login';
    }
  }

  const ErrorMessage = "Password errata";
  let showWrongPassword = false;
  let checkingPassword = false;
  let pwd = "";
  let type = "password";

  let progressTimeMS = 1000;

  function setType(newType) {
    type = newType;
  }

  function checkPassword() {
    checkingPassword = true;
    showWrongPassword = false;

    const wait = setTimeout(() => {
      if (pwd != AppPassword) {
        showWrongPassword = true;
        checkingPassword = false;
        return;
      }

      checkingPassword = false;

      AppAccessGranted.set('true');
      clearTimeout(wait);
    
    }, progressTimeMS);
  }
</script>


  <div class="center" out:fly="{{ y: -200, duration: 500 }}">
    <div class="rpgui-container framed-golden" style="padding: 1rem .5rem">
      <h1>Private Area</h1>

      {#if showWrongPassword}
        <p style="color:red">{ErrorMessage}</p>
      {/if}
      {#if checkingPassword}
        <ProgressBar timeToCompleteMS={progressTimeMS} color="green" />
      {/if}

      <div>
        {#if type == 'password'}
          <input
            type="password"
            placeholder="insert password"
            bind:value={pwd} />
          <span style="color:#eee;" on:click={() => setType('text')}>
            mostra password
          </span>
        {:else}
          <input type="text" placeholder="insert password" bind:value={pwd} />
          <span style="color:#eee;" on:click={() => setType('password')}>
            nascondi password
          </span>
        {/if}
      </div>

      <div class="text-center" style="margin-top:1.5rem">
        <button class="rpgui-button" on:click={() => checkPassword()}>
          ENTRA
        </button>
      </div>
    </div>
  </div>